import React from 'react';
import { Header, Segment, Table, Button, Loader, Message, Checkbox } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;

class CopyStudyProgramCourses extends React.Component {
    constructor(props) {
        super(props);

        const newSP = this.props.newSP
            ? this.props.newSP
            : ((this.props.location.state && this.props.location.state.newSP)
                ? this.props.location.state.newSP
                : JSON.parse(localStorage.getItem('newSP')));

        const sourceImplementation = this.props.implementation
            ? this.props.implementation
            : ((this.props.location.state && this.props.location.state.implementation)
                ? this.props.location.state.implementation
                : JSON.parse(localStorage.getItem('sourceImplementation')));

        this.state = {
            loading: true,
            copying: false,
            copied: false,
            error: false,

            newSP,
            sourceImplementation,

            oldCourses: [],
            oldSemesters: [],
            newSemesters: [],
            selectedCourses: []
        };

        this.getOldCourses = this.getOldCourses.bind(this);
        this.getOldSemesters = this.getOldSemesters.bind(this);
        this.getNewSemesters = this.getNewSemesters.bind(this);
        this.copyAllCourses = this.copyAllCourses.bind(this);
        this.copySemesterInfo = this.copySemesterInfo.bind(this);
        this.findNewSemester = this.findNewSemester.bind(this);
        this.createCourseOnNewProgram = this.createCourseOnNewProgram.bind(this);
        this.attachRemainingSemestersToCourse = this.attachRemainingSemestersToCourse.bind(this);
        this.handleSelectCourse = this.handleSelectCourse.bind(this);
        this.handleSelectAllCourses = this.handleSelectAllCourses.bind(this);
        this.isCourseSelected = this.isCourseSelected.bind(this);
    }

    componentDidMount() {
        if (this.props.showImplementationCopiedToast) {
            toast('Implementacija studijskog programa je uspješno kopirana.');
        }

        Promise.all([
            this.getOldCourses(),
            this.getOldSemesters(),
            this.getNewSemesters()
        ])
            .then(() => {
                this.setState({ loading: false });
            })
            .catch((err) => {
                console.log('Greška pri učitavanju podataka', err);
                this.setState({ loading: false, error: true });
                toast('Greška pri učitavanju podataka za kopiranje.');
            });
    }

    getOldCourses() {
        const { sourceImplementation } = this.state;

        return axios.post('study-programs/courses', {
            studyProgramId: sourceImplementation.studyProgram.id
        }).then(res => {
            const sortedCourses = (res.data || [])
                .map(el => ({
                    ...el,
                    courseBasicName: el.courseStudyProgram.courseBasic.name
                }))
                .sort((a, b) => {
                    const aSemester = (a.studyProgramSemesters && a.studyProgramSemesters.length && a.studyProgramSemesters[0].studyProgramSemester)
                        ? a.studyProgramSemesters[0].studyProgramSemester.number
                        : Number.MAX_SAFE_INTEGER;

                    const bSemester = (b.studyProgramSemesters && b.studyProgramSemesters.length && b.studyProgramSemesters[0].studyProgramSemester)
                        ? b.studyProgramSemesters[0].studyProgramSemester.number
                        : Number.MAX_SAFE_INTEGER;

                    if (aSemester !== bSemester) {
                        return aSemester - bSemester;
                    }

                    return a.courseBasicName.localeCompare(b.courseBasicName);
                });

            this.setState({
                oldCourses: sortedCourses
            });
        });
    }

    getOldSemesters() {
        const { sourceImplementation } = this.state;

        return axios.get(`study-programs/semesters/${sourceImplementation.studyProgram.id}`)
            .then(res => {
                this.setState({
                    oldSemesters: res.data || []
                });
            });
    }

    getNewSemesters() {
        const { newSP } = this.state;

        return axios.get(`study-programs/semesters/${newSP.id}`)
            .then(res => {
                this.setState({
                    newSemesters: res.data || []
                });
            });
    }

    handleSelectCourse(courseId) {
        this.setState(prevState => {
            const exists = prevState.selectedCourses.includes(courseId);

            return {
                selectedCourses: exists
                    ? prevState.selectedCourses.filter(id => id !== courseId)
                    : [...prevState.selectedCourses, courseId]
            };
        });
    }

    handleSelectAllCourses() {
        const { oldCourses, selectedCourses } = this.state;

        const selectableCourseIds = oldCourses
            .filter(course => (course.studyProgramSemesters || []).length > 0)
            .map(course => course.courseStudyProgram.id);

        const allSelected = selectableCourseIds.length > 0
            && selectableCourseIds.every(id => selectedCourses.includes(id));

        this.setState({
            selectedCourses: allSelected ? [] : selectableCourseIds
        });
    }

    isCourseSelected(courseId) {
        return this.state.selectedCourses.includes(courseId);
    }

    findNewSemester(oldSemester) {
        const { newSemesters } = this.state;

        if (!oldSemester || !oldSemester.studyProgramSemester) return null;

        return newSemesters.find(el =>
            el.studyProgramSemester &&
            el.studyProgramSemester.id === oldSemester.studyProgramSemester.id
        ) || null;
    }

    async copySemesterInfo() {
        const { oldSemesters } = this.state;

        for (let i = 0; i < oldSemesters.length; i += 1) {
            const oldSemester = oldSemesters[i];
            const newSemester = this.findNewSemester(oldSemester);

            if (!newSemester) continue;

            const semesterObj = {
                optionalCoursesECTSMin: oldSemester.optionalCoursesECTSMin,
                optionalCoursesECTSMax: oldSemester.optionalCoursesECTSMax,
                optionalCoursesNumberMin: oldSemester.optionalCoursesNumberMin,
                optionalCoursesNumberMax: oldSemester.optionalCoursesNumberMax,
                studyProgramSemesterId: newSemester.studyProgramSemester.id,
                optlock: newSemester.optLock,
                id: newSemester.id
            };

            await axios.put('study-programs/semesters/', { ...semesterObj });
        }
    }

    async createCourseOnNewProgram(oldCourseRow) {
        const { newSP } = this.state;
        const csp = oldCourseRow.courseStudyProgram;
        const oldCourseSemesters = oldCourseRow.studyProgramSemesters || [];

        if (!oldCourseSemesters.length) {
            throw new Error(`Predmet ${oldCourseRow.courseBasicName} nema dodijeljen semestar.`);
        }

        const firstOldSemester = oldCourseSemesters[0];
        const firstNewSemester = this.findNewSemester(firstOldSemester);

        if (!firstNewSemester) {
            throw new Error(`Nije pronađen odgovarajući semestar za predmet ${oldCourseRow.courseBasicName}.`);
        }

        const courseBasicId = csp.courseBasic && csp.courseBasic.id ? csp.courseBasic.id : null;

        const courseObj = {
            studyProgramId: newSP.id,
            code: csp.code,
            ects: csp.ects,
            lectureNumber: csp.lectureNumber,
            exerciseNumber: csp.exerciseNumber,
            seminarNumber: csp.seminarNumber,
            tutorialNumber: csp.tutorialNumber,
            mandatory: csp.mandatory,
            fromOtherStudyProgram: csp.fromOtherStudyProgram,
            prerequisiteCourse: csp.prerequisiteCourse,
            courseBasicId
        };

        const createSemObj = {
            courses: [courseObj],
            studyProgramSemesterId: firstNewSemester.id
        };

        await axios.post('study-programs/semesters/courses/', { ...createSemObj });

        return courseBasicId;
    }

    async attachRemainingSemestersToCourse(courseBasicId, oldCourseRow) {
        const oldCourseSemesters = oldCourseRow.studyProgramSemesters || [];

        for (let i = 1; i < oldCourseSemesters.length; i += 1) {
            const oldSemester = oldCourseSemesters[i];
            const newSemester = this.findNewSemester(oldSemester);

            if (!newSemester) continue;

            const obj = { id: courseBasicId };

            await axios.post(
                `study-programs/course/add-semester/${parseInt(newSemester.id, 10)}`,
                { ...obj }
            );
        }
    }

    async copyAllCourses() {
        const { oldCourses, selectedCourses } = this.state;

        if (!selectedCourses.length) {
            toast('Morate označiti barem jedan predmet za kopiranje.');
            return;
        }

        this.setState({ copying: true });

        try {
            await this.copySemesterInfo();

            const coursesToCopy = oldCourses.filter(course =>
                selectedCourses.includes(course.courseStudyProgram.id)
            );

            for (let i = 0; i < coursesToCopy.length; i += 1) {
                const oldCourseRow = coursesToCopy[i];
                const oldCourseSemesters = oldCourseRow.studyProgramSemesters || [];

                if (!oldCourseSemesters.length) {
                    continue;
                }

                const courseBasicId = await this.createCourseOnNewProgram(oldCourseRow);
                await this.attachRemainingSemestersToCourse(courseBasicId, oldCourseRow);
            }

            this.setState({
                copying: false,
                copied: true
            });

            toast('Predmeti i informacije o semestrima su uspješno kopirani.');

            if (this.props.onFinish) {
                this.props.onFinish();
            }
        } catch (err) {
            console.log('Greška pri kopiranju predmeta', err.response || err);

            let msg = 'Došlo je do greške pri kopiranju predmeta ili informacija o semestrima.';
            try {
                if (err.response && err.response.data) {
                    if (typeof err.response.data === 'string' && err.response.data.includes('You must enter the course through the course section.')) {
                        msg = 'Predmet se nalazi u listi predmeta za ovu implementaciju, te ga je potrebno tu i unijeti!';
                    } else if (typeof err.response.data === 'string' && err.response.data.includes('Course already exists in semester.')) {
                        msg = 'Predmet se već nalazi u semestru!';
                    } else if (typeof err.response.data === 'string' && err.response.data.includes('Course must belong to at least one semester.')) {
                        msg = 'Predmet se nalazi u listi predmeta, ali mu nije dodijeljen semestar!';
                    } else if (typeof err.response.data === 'string') {
                        msg = err.response.data;
                    }
                } else if (err.message) {
                    msg = err.message;
                }
            } catch (e) {}

            this.setState({
                copying: false,
                copied: false
            });

            toast(msg);
        }
    }

    render() {
        const {
            loading,
            copying,
            error,
            sourceImplementation,
            newSP,
            oldCourses,
            selectedCourses
        } = this.state;

        if (!sourceImplementation || !newSP) {
            return null;
        }

        if (loading) {
            return (
                <Segment basic>
                    <Loader active inline="centered" />
                </Segment>
            );
        }

        const selectableCourseIds = oldCourses
            .filter(course => (course.studyProgramSemesters || []).length > 0)
            .map(course => course.courseStudyProgram.id);

        const allSelected = selectableCourseIds.length > 0
            && selectableCourseIds.every(id => selectedCourses.includes(id));

        return (
            <div>
                <Header as="h1">Kopiranje predmeta</Header>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                Kopiranje predmeta sa implementacije: {sourceImplementation.studyProgram.name}
                            </Header.Content>
                            <Header.Subheader>
                                Novi program: {newSP.name}
                            </Header.Subheader>
                        </Header>

                        <Message>
                            Označite predmete koje želite kopirati. Predmet možete označiti klikom na kvadratić ili klikom na cijeli red.
                            Kvadratić u zaglavlju omogućava označavanje svih predmeta koji imaju dodijeljen semestar.
                        </Message>

                        {error && (
                            <Message negative>
                                Došlo je do greške pri učitavanju podataka.
                            </Message>
                        )}
                    </Segment>

                    <Segment clearing>
                        {oldCourses.length ? (
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign="center" width={1}>
                                            <Checkbox
                                                checked={allSelected}
                                                onChange={this.handleSelectAllCourses}
                                            />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell>Naziv predmeta</Table.HeaderCell>
                                        <Table.HeaderCell>ECTS</Table.HeaderCell>
                                        <Table.HeaderCell>Šifra</Table.HeaderCell>
                                        <Table.HeaderCell>Semestar</Table.HeaderCell>
                                        <Table.HeaderCell>Tip predmeta</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {oldCourses.map((el, index) => {
                                        const courseId = el.courseStudyProgram.id;
                                        const hasSemester = (el.studyProgramSemesters || []).length > 0;
                                        const checked = this.isCourseSelected(courseId);

                                        return (
                                            <Table.Row
                                                key={index}
                                                onClick={() => {
                                                    if (!hasSemester) return;
                                                    this.handleSelectCourse(courseId);
                                                }}
                                                active={checked}
                                                disabled={!hasSemester}
                                                style={{ cursor: hasSemester ? 'pointer' : 'default' }}
                                            >
                                                <Table.Cell textAlign="center" onClick={(e) => e.stopPropagation()}>
                                                    <Checkbox
                                                        checked={checked}
                                                        disabled={!hasSemester}
                                                        onChange={() => this.handleSelectCourse(courseId)}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell>{el.courseBasicName}</Table.Cell>
                                                <Table.Cell>{el.courseStudyProgram.ects}</Table.Cell>
                                                <Table.Cell>{el.courseStudyProgram.code}</Table.Cell>
                                                <Table.Cell>
                                                    {(el.studyProgramSemesters || []).map((e, i) => (
                                                        <div key={i}>
                                                            {e.studyProgramSemester ? e.studyProgramSemester.name : ''}
                                                        </div>
                                                    ))}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {el.courseStudyProgram.mandatory ? 'Obavezan' : 'Izborni'}
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    })}
                                </Table.Body>
                            </Table>
                        ) : (
                            <NoDataMessage />
                        )}

                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.copyAllCourses}
                            loading={copying}
                            disabled={copying || !oldCourses.length}
                        >
                            Kopiraj označene predmete
                        </Button>

                        <Button
                            floated="right"
                            basic="true"
                            color="blue"
                            onClick={() => this.props.history.push('/osnovni-studijski-programi/implementacije')}
                        >
                            Odustani
                        </Button>
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}

export default CopyStudyProgramCourses;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/CopyStudyProgramCourses.js